import { createProviderToken } from '@core/common-legacy';
import { ReportsAppKind } from '@core/reports-types';

export const { inject: injectReportsAppKind, provide: provideReportsAppKind } =
  createProviderToken<ReportsAppKind>('ReportsAppKind')();
